import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export const DateField = ({ label, value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  const pick = (d) => {
    if (!d) return;
    onChange(format(d, "yyyy-MM-dd"));
    setOpen(false);
  };
  return (
    <div className="text-[10px] uppercase tracking-widest flex items-center gap-1">
      {label}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId}
                  className="border-2 border-black px-2 py-1 text-xs bg-white inline-flex items-center gap-1.5 normal-case tracking-normal hover:bg-zinc-50 transition-colors">
            <CalendarBlank size={12} weight="bold" />
            {selected ? format(selected, "MMM d, yyyy") : "Pick a date"}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 border-2 border-black rounded-none shadow-[4px_4px_0_#000]" align="start">
          <div data-testid={`${testId}-calendar`}>
            <Calendar mode="single" selected={selected} defaultMonth={selected} onSelect={pick}
                      disabled={{ after: new Date() }} initialFocus />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
